/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:764c457f-4c5c-4712-8682-5edbc8532e25",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_hYExCW4HV",
    "aws_user_pools_web_client_id": "2572g660jgkhg10i5shqv70tv4",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "Analytics": {
        "AWSPinpoint": {
            "appId": "9afd776d20304c3982677dede8c48ff9",
            "region": "eu-central-1"
        }
    }
};


export default awsmobile;
